import { Typography } from '@mui/material';
import styled from 'styled-components';
import { Theme } from '@mui/material/styles';

const FormContainer = styled.div`
  color: ${({ theme }) => theme.palette.primary};
  margin-left: ${({ theme }) => theme.spacing(3)};
  margin-right: ${({ theme }) => theme.spacing(3)};
  margin-top: ${({ theme }) => theme.spacing(3)};
  overflow-y: auto;
  max-height: calc(100vh - 20px);
`;

const SectionTitle = styled(Typography).attrs((attrs) => ({
  ...attrs,
  variant: 'h2',
}))`
  color: ${({ theme }) => theme.palette.primary};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

const InputRowContainer = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: row;

  margin-bottom: ${({ theme }) => theme.spacing(2)};

  & > div {
    flex: 1;
    margin-left: ${({ theme }) => theme.spacing(1.5)};
  }

  & > div:first-child {
    margin-left: 0;
  }
`;

export { FormContainer, SectionTitle, InputRowContainer };
